// extracted by mini-css-extract-plugin
export var notificationHost = "_c2-0";